import type { LanguageCodes } from '@/types'
type LanguageLabels = {
    playermode: string
    quizesmode: string
    readmode: string
	readmoreTooltip:string
	leadText:string
	keymessages:string
    prequiz: string
    postquiz: string
    playlabel: string
    presentation: string
    backbtn: string
    referenceslabel: string
    helpfulquestion: string
    veryhelpful: string
    helpful: string
    nothelpful: string
    prepareprint: string
	printBtn:string,
	questionLabel:string
	survey:string
	feedbackBtn:string
	notificationBtn:string,
	leavefeedbackmsg:string
	readCallAssistantToolTipLabel:string
	document:string
	simpleList:string
	groupList:string
	searchBtn:string
	searchPlaceholder:string
	noItemsMore:string
	loadMore:string
	loading:string
	noResults:string
	noReference:string
	callAssistant:string
	titleLabel:string
	descriptionLabel:string
	copyrightLabel:string
}

export const messages: Record<LanguageCodes, LanguageLabels> = {
	
	auto: {
		playermode: '',
		quizesmode: '',
		readmode: '',
		readmoreTooltip:'',
		leadText: '',
		keymessages: '',
		prequiz: '',
		postquiz: '',
		playlabel: '',
		presentation: '',
		backbtn: '',
		referenceslabel: '',
		helpfulquestion: '',
		veryhelpful: '',
		helpful: '',
		nothelpful: '',
		prepareprint: '',
		printBtn: '',
		questionLabel: '',
		survey: '',
		feedbackBtn: '',
		notificationBtn: '',
		leavefeedbackmsg: '',
		readCallAssistantToolTipLabel: '',
		document: '',
		simpleList: '',
		groupList: '',
		searchBtn: '',
		searchPlaceholder: '',
		noItemsMore: '',
		loadMore: '',
		loading: '',
		noResults: '',
		noReference: '',
		callAssistant: '',
		titleLabel: '',
		descriptionLabel: '',
		copyrightLabel: ''

	},
	de: {
		playermode: 'Wiedergabeliste',
		quizesmode: 'Quiz-Modus',
		readmode: 'Weiterlesen',
		readmoreTooltip:'Learn  more about this post',
		leadText: 'Leittext',
		keymessages: 'Schlüsselbotschaften',
		prequiz: 'Prä-Quiz',
		postquiz: 'Post-Quiz',
		playlabel: 'Vorlesen',
		presentation: 'Präsentation',
		backbtn: 'Zurück',
		referenceslabel: 'Referenzen',
		helpfulquestion: 'War diese Review hilfreich?',
		veryhelpful: 'Sehr hilfreich',
		helpful: 'Hilfreich',
		nothelpful: 'Nicht hilfreich',
		prepareprint: 'Druckvorbereitung',
		printBtn: 'Drucken',
		questionLabel: 'Frage',
		survey: 'Dein Feed-back',
		leavefeedbackmsg: 'Hinterlassen Sie Ihr Feedback',
		readCallAssistantToolTipLabel: 'Lesen Sie den Call Assistant',
		feedbackBtn: 'Feed-back',
		notificationBtn: 'Notification',
		document: 'Dokument',
		simpleList: 'einfache Liste',
		groupList: 'Gruppenliste',
		searchBtn: 'Suche',
		searchPlaceholder: 'Beitrag(e) suchen',
		noItemsMore: 'Nicht mehr Artikel',
		loadMore: 'Mehr Artikel',
		loading: 'Laden',
		noResults: 'Es wurden keine Artikel für dieses Spezialgebiet gefunden',
		noReference: 'Referenzen wurden noch nicht hinzugefügt.',
		callAssistant: 'Anrufassistent',
		titleLabel: 'Titel:',
		descriptionLabel: 'Beschreibung:',
		copyrightLabel: 'Copyright:'
	},
	fr: {
		playermode: 'Liste de lecture',
		quizesmode: 'Quiz-Modus',
		readmode: 'Lire la suite',
		readmoreTooltip:'Learn  more about this post',
		leadText: 'Texte principal',
		keymessages: 'Messages clés',
		prequiz: 'Pré-quiz',
		postquiz: 'Post-Quiz',
		playlabel: 'Lis-le-moi',
		presentation: 'Présentation',
		backbtn: 'Arrière',
		referenceslabel: 'Références',
		helpfulquestion: 'Cet avis a-t-il été utile?',
		veryhelpful: 'Très serviable',
		helpful: 'Serviable',
		nothelpful: 'Pas serviable',
		prepareprint: 'Préparation à l`impression',
		printBtn: 'l`impression',
		questionLabel: 'Question',
		survey: 'Vos commentaires',
		leavefeedbackmsg: 'Laissez vos commentaires',
		readCallAssistantToolTipLabel: 'Lire le Call Assistant',
		feedbackBtn: 'Commentaires',
		notificationBtn: 'Notification',
		document: 'Document',
		simpleList: 'Simple List',
		groupList: 'Group List',
		searchBtn: 'Rechercher',
		searchPlaceholder: 'Rechercher des articles d\'évaluation',
		noItemsMore: 'Not more items',
		loadMore: 'Load More',
		loading: 'Loading',
		noResults: 'Aucun article trouvé pour cette spécialité.',
		noReference: 'Les références nont pas encore été ajoutées.',
		callAssistant: 'Assistant d\'appel',
		titleLabel: 'Titre:',
		descriptionLabel: 'La description:',
		copyrightLabel: 'Copyright:'
	},
	it: {
		playermode: 'Modalità lettore',
		quizesmode: 'Modalità Quiz',
		readmode: 'Continua a leggere',
		readmoreTooltip:'Learn  more about this post',
		leadText: 'Testo principale',
		keymessages: 'Messaggi chiave',
		prequiz: 'Pre-Quiz',
		postquiz: 'Post-Quiz',
		playlabel: 'Leggimelo',
		presentation: 'Presentazione',
		backbtn: 'Indietro',
		referenceslabel: 'Riferimenti',
		helpfulquestion: 'Questa recensione è stata utile?',
		veryhelpful: 'Molto utile',
		helpful: 'Utile',
		nothelpful: 'Non utile',
		prepareprint: 'Preparazione per la stampa',
		printBtn: 'Stampa',
		questionLabel: 'Domanda',
		feedbackBtn: 'Feedback',
		notificationBtn: 'Notification',
		leavefeedbackmsg: 'Lascia il tuo feedback',
		readCallAssistantToolTipLabel: 'Leggi il Call Assistant',
		survey: 'Il tuo feedback',
		document: 'Documento',
		simpleList: 'Simple List',
		groupList: 'Group List',
		searchBtn: 'Ricerca',
		searchPlaceholder: 'Cerca post di recensione',
		noItemsMore: 'Not more items',
		loadMore: 'Load More',
		loading: 'Loading',
		noResults: 'Non sono stati trovati articoli per questa specialità.',
		noReference: 'I riferimenti non sono ancora stati aggiunti.',
		callAssistant: 'Assistente',
		titleLabel: 'Titolo:',
		descriptionLabel: 'Descrizione:',
		copyrightLabel: 'Copyright:'
	},
	en: {
		playermode: 'Player Mode',
		quizesmode: 'Quiz Mode',
		keymessages: 'Key Messages',
		leadText: 'Lead text',
		readmode: 'Learn more',
		readmoreTooltip:'Learn  more about this post',
		prequiz: 'Pre-Quiz',
		postquiz: 'Post-Quiz',
		playlabel: 'Read it to me',
		presentation: 'Presentation',
		backbtn: 'Back',
		referenceslabel: 'References',
		helpfulquestion: 'Was this review helpful?',
		veryhelpful: 'Very Helpful',
		helpful: 'Helpful',
		nothelpful: 'Not Helpful',
		prepareprint: 'Preparing for printing',
		printBtn: 'Print',
		questionLabel: 'Question',
		feedbackBtn: 'Feedback',
		notificationBtn: 'Notification',
		leavefeedbackmsg: 'Your feedback helps us improve.',
		readCallAssistantToolTipLabel: 'Call Help & Support Assistant (Beta Version)',
		survey: 'Your feedback',
		document: 'Document',
		simpleList: 'Simple List',
		groupList: 'Group List',
		searchBtn: 'Search',
		searchPlaceholder: 'Search review post(s)',
		noItemsMore: 'Not more items',
		loadMore: 'Load More',
		loading: 'Loading',
		noResults: 'There are no contributions available.',
		noReference: 'References have not been added yet.',
		callAssistant: 'Test Yourself interacting with Assistant (Beta version)',
		titleLabel: 'Title:',
		descriptionLabel: 'Description:',
		copyrightLabel: 'Copyright:'
	},
	sq: {
		playermode: 'Modaliteti Audio',
		quizesmode: 'Modaliteti Quiz',
		readmode: 'Lexo më shumë',
		readmoreTooltip:'Learn  more about this post',
		leadText: 'Teksti kryesor',
		keymessages: 'Mesazhet Kryesore',
		prequiz: 'Pre-Quiz',
		postquiz: 'Post-Quiz',
		playlabel: 'Lexoje për mua',
		presentation: 'Prezantimi',
		backbtn: 'Mbrapa',
		referenceslabel: 'Referencat',
		helpfulquestion: 'A ishte e dobishme kjo përmbledhje?',
		veryhelpful: 'Shumë e dobishme',
		helpful: 'E dobishme',
		nothelpful: 'E pa dobishme',
		prepareprint: 'Përgatitje për printim',
		printBtn: 'Printo',
		questionLabel: 'Pyetja',
		feedbackBtn: 'Feedback',
		notificationBtn: 'Notification',
		leavefeedbackmsg: 'Lini reagimet tuaja',
		readCallAssistantToolTipLabel: 'Lexo Call Assistant',
		survey: 'Komentet tuaja',
		document: 'Dokument',
		simpleList: 'Listë e thjeshtë',
		groupList: 'Listë e grupuar',
		searchBtn: 'Kërko',
		searchPlaceholder: 'Kërko postim(e)',
		noItemsMore: 'Nuk ka më postim(e)',
		loadMore: 'Shaq më shume...',
		loading: 'Po Ngarkohen...',
		noResults: 'Nuk ka asnjë artikull për këtë specialitet',
		noReference: 'Referencat nuk janë shtuar akoma.',
		callAssistant: 'Thirr Asistentin',
		titleLabel: 'Titulli:',
		descriptionLabel: 'Përshkrimi:',
		copyrightLabel: 'Copyright:'
	},
	hu: {
		playermode: 'Játékos mód',
		quizesmode: 'Quiz mód',
		readmode: 'Olvass tovább',
		readmoreTooltip:'Tudjon meg többet erről a bejegyzésről.',
		leadText: 'Bevezető szöveg',
		keymessages: 'Tanulási eredmény',
		prequiz: 'Előkvíz',
		postquiz: 'Kvíz utáni',
		playlabel: 'Olvasd fel nekem',
		presentation: 'Előadás',
		backbtn: 'Vissza',
		referenceslabel: 'Hivatkozások',
		helpfulquestion: 'Hasznos volt ez az értékelés?',
		veryhelpful: 'Nagyon hasznos',
		helpful: 'Hasznos',
		nothelpful: 'Nem hasznos',
		prepareprint: 'Nyomtatás előkészítése',
		printBtn: 'Nyomtatás',
		questionLabel: 'Kérdés',
		feedbackBtn: 'Feedback',
		notificationBtn: 'Notification',
		leavefeedbackmsg: 'Visszajelzése hozzájárul a fejlődésünkhöz.',
		readCallAssistantToolTipLabel: 'Hívja a Help & Support asszisztenst (Béta verzió)',
		survey: 'Véleményed',
		document: 'Dokumentum',
		simpleList: 'Egyszerű lista',
		groupList: 'Csoportosított lista',
		searchBtn: 'Keresés',
		searchPlaceholder: 'Keresés a véleményezési bejegyzésekben',
		noItemsMore: 'Nem több elemet',
		loadMore: 'Továbbiak betöltése',
		loading: 'Betöltés',
		noResults: 'Nincsenek elérhető előadások.',
		noReference: 'Hivatkozások még nem kerültek hozzáadásra.',
		callAssistant: 'Hívássegédséges',
		titleLabel: 'Cim:',
		descriptionLabel: 'Leírás:',
		copyrightLabel: 'Szabadon használhato'
	}
}
